var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Browser',{key:_vm.updateWhenParamsChange})
}
var staticRenderFns = []

export { render, staticRenderFns }